//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconNavExplore(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M12.0002 2C7.53017 2 3.74017 4.95 2.46017 9H4.59017C5.42017 6.96 7.07017 5.34 9.13017 4.54L6.78017 11H2.05017C1.46017 16.89 6.10017 22 12.0002 22C17.5102 22 22.0002 17.51 22.0002 12C22.0002 6.49 17.5102 2 12.0002 2ZM11.4402 4.03C12.0102 3.99 12.0102 3.99 12.5302 4.03L15.0702 11H8.90017L11.4402 4.03ZM4.07017 13H6.78017L9.13017 19.46C6.43017 18.41 4.44017 15.96 4.07017 13ZM11.4402 19.97L8.90017 13H15.0702L12.5302 19.97C12.0202 20.01 12.0102 20.01 11.4402 19.97ZM14.8502 19.47L17.2002 13H19.9302C19.5602 15.97 17.5502 18.43 14.8502 19.47ZM17.2002 11L14.8502 4.53C17.5602 5.57 19.5602 8.03 19.9302 11H17.2002Z" fill="currentColor" /></svg>;
}
export default IconNavExplore;